import { Observable } from "rxjs/Observable"

import { mapRequestError } from "./default-epics/epic-utils"
import {
    DASHBOARD_INFO_REQUEST,
    DASHBOARD_KNOWLEDGE_SEARCH_REQUEST,
    DASHBOARD_KNOWLEDGE_PAGE_REQUEST
} from "../actions/action-types"
import {
    dashboardInfoResponse,
    dashboardInfoCachedResponse,
    dashboardInfoErrorResponse,
    dashboardKnowledgePageRequest
} from "../actions/dashboard-actions"
import { unauthenticated } from "../actions/authentication-actions"
import { moderationListRequest } from "../actions/moderation-feed-actions"
import { dashboardInfoCacheLimit } from "../config/cache-limits"
import { getDashboardInfo } from "../api/dashboard-info-api"
import { requestListSearchEpic } from "./default-epics/default-entity-epics"

export const requestDashboardInfoEpic = (action$, { getState }) =>
    action$.ofType(DASHBOARD_INFO_REQUEST).mergeMap(() => {
        const { data, lastUpdatedAt } = getState().entities.dashboardInfo
        const isCached =
            data && Date.now() - lastUpdatedAt < dashboardInfoCacheLimit
        if (isCached) return Observable.of(dashboardInfoCachedResponse())
        else
            return getDashboardInfo(getState().authentication.token)
                .map(data => dashboardInfoResponse(data))
                .catch(error =>
                    Observable.of(
                        mapRequestError(
                            error,
                            unauthenticated,
                            dashboardInfoErrorResponse
                        )
                    )
                )
    })

export const requestDashboardKnowledgeSearchEpic = requestListSearchEpic(
    DASHBOARD_KNOWLEDGE_SEARCH_REQUEST,
    dashboardKnowledgePageRequest,
    "dashboard",
    "moderationFeed"
)

export const requestDashboardKnowledgePageEpic = (action$, store) =>
    action$
        .ofType(DASHBOARD_KNOWLEDGE_PAGE_REQUEST)
        .map(({ type, ...pagingRequest }) =>
            moderationListRequest(pagingRequest)
        )
